import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import * as ST from './styled';

const getElementIndex = (options, selectedId) => {
    return options.findIndex(item => item.id === selectedId);
};

const getDisplayOptions = (options, selectedIndex, countBtn) => {
    const lengthBtns = options.length - countBtn;
    const firstIndex = lengthBtns < 0 ? 0 : lengthBtns;
    const mid = Math.floor(countBtn / 2);
    const secondIndex = selectedIndex > 0 ? selectedIndex - mid : 0;
    const startIndex = firstIndex < secondIndex ? firstIndex : secondIndex;
    return options.slice(startIndex, startIndex + countBtn);

};

export const PaginationLinks = (props) => {
    const { options, selectedId, countBtns, href, as, query } = props;
    const selectedIndex = getElementIndex(options, selectedId);
    const displayOptions = getDisplayOptions(options, selectedIndex, countBtns);
    const isFirstElement = selectedIndex === 0 || options.length === 0;
    const isLastElement = options.length === selectedIndex + 1;

    return (
        <ST.PaginationContainer>
            {!isFirstElement &&
                <Link
                    href={{ pathname: href, query: { ...query, page: selectedId - 1 } }}
                    as={{ pathname: as, query: { ...query, page: selectedId - 1 } }}
                    scroll={false}
                    passHref
                    data-test='btn-prev'
                >
                    <ST.Prev />
                </Link>
            }
            <ST.BtnWrap data-test='btns-wrap'>
                {displayOptions.map(item => {
                    return (
                        <Link
                            key={item.id}
                            href={{ pathname: href, query: { ...query, page: item.value } }}
                            as={{ pathname: as, query: { ...query, page: item.value } }}
                            scroll={false}
                            passHref
                        >
                            <ST.Btn isActive={item.id === selectedId} data-test='btn-link'>
                                {item.label}
                            </ST.Btn>
                        </Link>
                    );
                })}
            </ST.BtnWrap>
            {!isLastElement &&
                <Link
                    href={{ pathname: href, query: { ...query, page: selectedId + 1 } }}
                    as={{ pathname: as, query: { ...query, page: selectedId + 1 } }}
                    scroll={false}
                    passHref
                >
                    <ST.Next data-test='btn-next' />
                </Link>
            }
        </ST.PaginationContainer>
    );
};

PaginationLinks.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            value: PropTypes.any,
        })
    ),
    selectedId: PropTypes.number,
    countBtns: PropTypes.number.isRequired,
    href: PropTypes.string,
    as: PropTypes.string,
    query: PropTypes.object,
};

PaginationLinks.defaultProps = {
    options: [],
    selectedId: null,
    href: '',
    as: '',
    query: {},
};
